export default "__VITE_ASSET__1fb0c47d__"